import { theme } from "antd";

export const Theme = {
  token: {
    fontFamily: 'Poppins,sans-serif',
    algorithm: theme.darkAlgorithm,
  },
  components: {
    Drawer: {
      headerBg: '#F6F5F5',
      colorBgElevated: '#F6F5F5',
      fontSizeLG: '20px',
      colorText: 'white',
      colorIcon: 'white',
    },
    Card: {
      headerBg: 'white',
      //colorTextHeading: 'white',
    },
    Table: {
      headerColor: 'white',
      headerBg: 'black'
    },
    Timeline: {
      colorPrimary: "#D2B174"
    }
  },
}